import React from 'react';
import ConfirmModal from 'containers/modals/Confirm';
import ConfirmRouteLeave from 'containers/modals/ConfirmRouteLeave';
import ConfirmDeleteModal from 'containers/modals/ConfirmDelete';
import ChangePassword from 'containers/modals/ChangePassword';
import AppFullDescription from 'containers/modals/AppFullDescription';
import CreateStore from 'partners/containers/modals/CreateStore';
import LinkStores from 'partners/containers/modals/LinkStores';
import TransferStoreOwnership from 'partners/containers/modals/TransferStoreOwnership';
import LinkApps from 'partners/containers/modals/LinkApps';
import BecomePartner from 'partners/containers/modals/BecomePartner';
import ListingCriteria from 'partners/containers/modals/ListingCriteria';
import SubmitListing from 'partners/containers/modals/SubmitListing';

export default function getModal(modalId, index, props) {
  switch (modalId) {
    case 'Confirm':
      return <ConfirmModal key={index} {...props} />;
    case 'ConfirmRouteLeave':
      return <ConfirmRouteLeave key={index} {...props} />;
    case 'ConfirmDelete':
      return <ConfirmDeleteModal key={index} {...props} />;
    case 'ChangePassword':
      return <ChangePassword key={index} {...props} />;
    case 'CreateStore':
      return <CreateStore key={index} {...props} />;
    case 'LinkStores':
      return <LinkStores key={index} {...props} />;
    case 'TransferStoreOwnership':
      return <TransferStoreOwnership key={index} {...props} />;
    case 'LinkApps':
      return <LinkApps key={index} {...props} />;
    case 'BecomePartner':
      return <BecomePartner key={index} {...props} />;
    case 'AppFullDescription':
      return <AppFullDescription key={index} {...props} />;
    case 'ListingCriteria':
      return <ListingCriteria key={index} {...props} />;
    case 'SubmitListing':
      return <SubmitListing key={index} {...props} />;
    default:
      break;
  }
}
